const feefoScript = () => {
    const old = document.querySelector('script[src*="feefo.com/api/javascript"]');
    if (old) {
        old.remove();
    }
    const s = document.createElement('script');
    s.src = 'https://api.feefo.com/api/javascript/carphone-warehouse';
    s.async = true;
    document.body.appendChild(s);
};
export default feefoScript;
